import React, { useEffect, useRef } from "react";
import { Button, Stack } from "@mui/material";
import { FaInfoCircle, FaUserPlus } from "react-icons/fa";
import AboutUsPage from "./AboutUsPage";
import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";
import CertificateCard from "../CertificateCard/CertificateCard";

const AboutUsComponent = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Ensure the page scrolls to the top on reload
    if (window.location.hash) {
      // Remove any hash in the URL
      window.history.replaceState(null, null, " ");
    }
  }, []);
  const faqRef = useRef(null); // Create a reference for the FAQList component

  const scrollToFAQ = () => {
    faqRef.current?.scrollIntoView({ behavior: "smooth" }); // Scroll to FAQList component
  };

  return (
    <>
      <Header />
      <main>
        <AboutUsPage />
        <CertificateCard />
      </main>
      <Footer onFAQClick={scrollToFAQ} />{" "}
      <Stack
        direction="row"
        spacing={2}
        justifyContent="space-around"
        alignItems="center"
        sx={{
          position: "fixed",
          bottom: 0,
          left: 0,
          width: "100%",
          height: "56px",
          backgroundColor: "white",
          borderTop: "1px solid #7A7A7A",

          // px: 1,
          display: { xs: "flex", sm: "flex", md: "none" },
          zIndex: 1300,
          // border: "1px solid red",
        }}
      >
        <Button
          variant="contained"
          startIcon={<FaUserPlus />}          
          sx={{
            backgroundColor: "rgb(5 78 146)",
            textTransform: "none",
            borderRadius: "8px",
            paddingLeft: "8px",
            fontSize: "1.1rem",
            px: 3,
          }}
        >
          Sign up now
        </Button>
        <Button
          variant="outlined"
          startIcon={<FaInfoCircle />}
          sx={{
            textTransform: "none",
            borderRadius: "8px",
            color: "rgb(5 78 146)",
            borderColor: "rgb(5 78 146)",
            fontSize: "1.1rem",
            px: 3,
          }}
        >
          Know more
        </Button>
      </Stack>
    </>
  );
};

export default AboutUsComponent;
